<mat-calendar [(selected)]="dateRange" (selectedChange)="selectedDateRange($event)" *ngIf="isRange"></mat-calendar>
<mat-calendar [(selected)]="date" (selectedChange)="selectedDateSingle($event)" *ngIf="!isRange"></mat-calendar>